import '../../App.css'
import React from 'react'
import Cards from '../Cards';
import Footer from '../Footer';

function Home() {
  return (
    <>
    <Cards/>
    <Footer/>
    </>
  );
}

export default Home;